module.exports = __webpack_public_path__ + "img/Logo-Emprendimiento.928613a6.png";